var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["account/templates/partials/address-form/address-3.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"c-form__field\">\n\n    ";
if(runtime.contextOrFrameLookup(context, frame, "currentGroupType") == "group2" || runtime.contextOrFrameLookup(context, frame, "currentGroupType") == "group8") {
output += "\n\n    <label for=\"address-3\" class=\"c-form__label\">";
output += runtime.suppressValue((lineno = 4, colno = 50, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_addressAndPayments-countryGroups-groupTwo-buildingNumOrName",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += "</label>\n\n    ";
;
}
else {
output += "\n\n    <label for=\"address-3\" class=\"c-form__label\">";
output += runtime.suppressValue((lineno = 8, colno = 50, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_addressAndPayments-globalFormField-addressThree",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += "</label>\n\n    ";
;
}
output += "\n\n    <input type=\"text\" name=\"address.address3\" id=\"address-3\" value=\"";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.memberLookup(((lineno = 12, colno = 80, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Address")),"get"), "Address[\"get\"]", context, ["temp"]))),"address")),"address3")), env.opts.autoescape);
output += "\" class=\"js-address-form-item c-form__text\" maxlength=\"35\" aria-describedby=\"address-3_error\"/>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["account/templates/partials/address-form/address-3.j2"] , dependencies)